import React from 'react';
import './App.css';
import Header from "./components/Header";
import ImageView from "./components/ImageView";
import HoverImageView from "./components/HoverImageView";

function App() {
  return (
    <div className="App">
      <Header></Header>
      <div className="App-wrapper">
        <div className="App-top">
          <ImageView></ImageView>
        </div>
        <div className="App-bottom">
          <div className="App-hover">
            <HoverImageView></HoverImageView>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
